import { useState } from 'react';
import { ChevronDown, ChevronRight, Check } from 'lucide-react';
import { MarkdownEditor } from '../../../components/ui/MarkdownEditor.jsx';

/**
 * Editor for a structured ORME reading (C2 or C3): the fixed sections rendered
 * as collapsible WYSIWYG editors. `map` is `{ [key]: text }`; `onChange(key,
 * text)` updates a single section. The underlying editor is a toolbar-based
 * rich-text editor (no raw markdown shown to the operator).
 */
export function StructuredReadingEditor({ defs, map, onChange }) {
  const [open, setOpen] = useState({});

  return (
    <div className="flex flex-col gap-2">
      {defs.map((d) => {
        const filled = (map[d.key] || '').trim().length > 0;
        const isOpen = Boolean(open[d.key]);
        return (
          <div key={d.key} className="overflow-hidden rounded-lg border border-border">
            <button
              type="button"
              onClick={() => setOpen((prev) => ({ ...prev, [d.key]: !prev[d.key] }))}
              className="flex w-full items-center gap-2 bg-surface px-3 py-2.5 text-left text-sm transition-colors hover:bg-surface-subtle"
            >
              {isOpen ? <ChevronDown className="h-4 w-4 text-ink-muted" /> : <ChevronRight className="h-4 w-4 text-ink-muted" />}
              <span className="font-medium text-ink">{d.label}</span>
              {filled && (
                <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-success/10 px-2 py-0.5 text-[11px] text-success">
                  <Check className="h-3 w-3" /> compilata
                </span>
              )}
            </button>
            {isOpen && (
              <div className="border-t border-border p-3">
                <MarkdownEditor
                  value={map[d.key] || ''}
                  onChange={(text) => onChange(d.key, text)}
                  minHeight={140}
                  placeholder="Scrivi il testo della sezione..."
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
